//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tasks from '@/js/tasks';
import use_metrics_service from '@/apps/use-metrics/services/use_metrics_service';
import LookerDashboardComponent from '@/components/LookerDashboardComponent';
// Importa Somos1Service si lo necesitas

export default {
  name: 'SummaryPage',
  components: {
    LookerDashboardComponent: LookerDashboardComponent
  },
  data: function data() {
    return {
      dashboardUrl: '',
      report: null,
      maintenance: true,
      keyTemplate: 1
    };
  },
  created: function created() {
    this.getReport();
  },
  methods: {
    onReloadDashboard: function onReloadDashboard() {
      this.getReport();
    },
    getReport: function getReport() {
      var _this = this;
      var data = {
        'report_id': "summary"
      };
      use_metrics_service.getReport(data).then(function (response) {
        _this.report = response.data;
        var v_params = [];
        if (_this.report.keys.length > 0) {
          for (var i = 0; i < _this.report.keys.length; i++) {
            v_params.push("\"v".concat(i + 1, "\":\"").concat(_this.report.keys[i], "\""));
          }
        }
        var v_params_string = v_params.join(',');
        var calc_query = '?params={' + v_params_string + '}';
        _this.dashboardUrl = _this.report.link + calc_query;
        _this.maintenance = _this.report.maintenance ? true : false;
        console.log(_this.dashboardUrl, 'dashboardUrl');
        _this.keyTemplate += 1;
      });
    }
  },
  computed: {
    // Tus métodos computados
  }
};